import { useState, useRef, useEffect } from 'react';

// Ô TẠO CÔNG VIỆC từ 1 tin nhắn — dùng CHUNG cho chat nội bộ (ChatWidget) & chat KH (CustomerChat).
// Nội dung ĐIỀN SẴN = nội dung tin nhắn (NV không phải gõ lại — chọn tin -> tạo việc -> chọn người là xong),
// vẫn sửa được. Component module-level để ổn định bộ gõ tiếng Việt (ô nội dung không bị tháo/gắn lại).
// GIAO CHO NHIỀU NGƯỜI: 1 việc CHUNG, tích nhiều người; ai (người tạo/bất kỳ người được giao) cũng hoàn thành được.
export default function ChatTaskModal({ msg, assigneeOptions = [], me, onCreate, onClose, title = '📋 Tạo công việc' }) {
  const [content, setContent] = useState(() => (msg?.text || '').slice(0, 500));
  const [assignees, setAssignees] = useState(() => new Set());
  const [q, setQ] = useState('');
  const [busy, setBusy] = useState(false);
  const myId = String(me?.id || me?._id || '');
  const prefilled = !!(msg?.text || '').trim();
  const taRef = useRef(null);
  useEffect(() => { if (!prefilled) taRef.current?.focus(); }, [prefilled]);

  const toggle = (id) => setAssignees((prev) => {
    const n = new Set(prev); const k = String(id);
    if (n.has(k)) n.delete(k); else n.add(k);
    return n;
  });
  const ql = q.trim().toLowerCase();
  const opts = assigneeOptions.filter((o) => !ql || String(o.name || '').toLowerCase().includes(ql));

  const submit = async () => {
    const text = content.trim();
    if (!text) { window.alert('Nhập nội dung công việc'); return; }
    if (!assignees.size) { window.alert('Chọn ít nhất 1 người thực hiện'); return; }
    setBusy(true);
    try {
      await onCreate({ content: text, assignees: [...assignees], fromMsgId: msg?._id || undefined });
      onClose();
    } catch (e) {
      window.alert(e?.response?.data?.message || 'Tạo công việc thất bại');
    } finally { setBusy(false); }
  };

  return (
    <div className="chat-lightbox" onClick={onClose}>
      <div className="chattask-modal" onClick={(e) => e.stopPropagation()}>
        <div className="chattask-modal-head"><b>{title}</b><button type="button" className="chattask-modal-x" onClick={onClose}>✕</button></div>
        {prefilled ? <div className="chattask-modal-src">Nội dung lấy từ tin nhắn (sửa được nếu cần)</div> : null}
        <label className="chattask-modal-label">Nội dung công việc</label>
        <textarea ref={taRef} className="chat-input" rows={3} value={content} onChange={(e) => setContent(e.target.value)} placeholder="Nội dung công việc…" />
        <label className="chattask-modal-label">Giao cho (chọn 1 hoặc nhiều người) <span className="small muted">· đã chọn {assignees.size}</span></label>
        {assigneeOptions.length > 6 && (
          <input className="chat-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="🔍 Tìm người…" style={{ marginBottom: 6 }} />
        )}
        <div style={{ maxHeight: 200, overflowY: 'auto', border: '1px solid var(--border)', borderRadius: 8 }}>
          {opts.length === 0 && <div className="small muted" style={{ padding: 8 }}>Không có người phù hợp.</div>}
          {opts.map((o, i) => (
            <label key={o.id} style={{ display: 'flex', gap: 10, alignItems: 'center', padding: '7px 10px', cursor: 'pointer', fontWeight: 400, borderTop: i ? '1px solid var(--line)' : 'none' }}>
              <input type="checkbox" checked={assignees.has(String(o.id))} onChange={() => toggle(o.id)} style={{ width: 'auto' }} />
              <span>{o.name}{String(o.id) === myId ? ' (bạn)' : ''}</span>
            </label>
          ))}
        </div>
        <div className="chattask-modal-actions">
          <button type="button" className="btn sm ghost" onClick={onClose}>Huỷ</button>
          <button type="button" className="btn sm" disabled={busy} onClick={submit}>＋ Tạo công việc</button>
        </div>
      </div>
    </div>
  );
}
